
export class NEWS {
    /* 
    dùng cho danh sách tin tức
    */
    public static readonly TIN = 'tin';
    /* 
    dùng cho chi tiết tin tức
    */
    public static readonly TIN_TUC = 'news';

    /**
     * Dùng cho Megastory
     */
    public static readonly MEGASTORY = 'megastory';

    /**
     * Dùng cho Landingpage
     */
    public static readonly LANDINGPAGE = 'landingpage';

    /**
     * Dùng cho tin tuyen sinh
     */
    public static readonly TIN_TUYEN_SINH = 'news-admissions';

    public static readonly TUYEN_DUNG = 'recruitment';
}

export class DU_AN {
    /* 
    dùng cho danh sách dự án
    */
    public static readonly DU_AN = 'DU_AN';

    /* 
    dùng cho chi tiết dự án
    */
    public static readonly CHI_TIET_DU_AN = 'CHI_TIET_DU_AN';
}

export class GALLERY {
    /**
     * link detail video
     */
    public static readonly CHI_TIET_GALLERY_VIDEO = 'gallery-video';

    /**
     * link detail hình
     */
    public static readonly CHI_TIET_GALLERY_HINH = 'gallery-hinh';

}